import React from "react";

const Home = () => {
    return (
        <div>
            <h1>Fish Life Home</h1>
        </div>
    );
};

export default Home;